/**
 * @module json-schema
 */
/** @pratico/json-schema */
import { isObject } from './is-object';

export function filterOutEmptyStringProperty(obj: any | any[]): any {
  if (Array.isArray(obj)) {
    const result: any[] = [];
    obj.forEach((value, key) => {
      result[key] = filterOutEmptyStringProperty(value);
    });
    return result;
  } else if (isObject(obj)) {
    const result: any = {};
    Object.keys(obj).forEach(key => {
      if (isObject(obj[key]) || Array.isArray(obj[key])) {
        result[key] = <any>filterOutEmptyStringProperty(obj[key]);
      } else {
        if (!''.endsWith(obj[key])) {
          result[key] = obj[key];
        }
      }
    });
    return result;
  } else {
    return obj;
  }
}
